import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-442bb16a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-12 items-stretch" }
const _hoisted_2 = { class: "flex items-center justify-between mt-0" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Pacakge & Billing ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-charcoal-ghost mention" }, "Packages:", -1))
const _hoisted_5 = { class: "flex gap-12" }
const _hoisted_6 = { class: "p-cell rounded-mention border border-warm flex-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mention font-medium" }, "Personal", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h1 font-semibold" }, [
  /*#__PURE__*/_createTextVNode(" $100 "),
  /*#__PURE__*/_createElementVNode("div", { class: "inline-block sub font-regular" }, "/ month")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "p-mention rounded-mention disabled-plan text-center"
}
const _hoisted_10 = { class: "p-cell rounded-mention border border-warm flex-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mention font-medium" }, "Team", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h1 font-semibold" }, [
  /*#__PURE__*/_createTextVNode(" $240 "),
  /*#__PURE__*/_createElementVNode("div", { class: "inline-block sub font-regular" }, "/ year")
], -1))
const _hoisted_13 = {
  key: 0,
  class: "p-mention rounded-mention disabled-plan text-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-charcoal-ghost mention" }, "Current Package:", -1))
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = { class: "mention" }
const _hoisted_17 = { class: "mention" }
const _hoisted_18 = { class: "mention" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" You current package costs ")
const _hoisted_20 = { class: "font-bold text-charcoal-ghost" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, "Edit Billing Information", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_stripe_checkout = _resolveComponent("stripe-checkout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Icon, {
        icon: ['fal', 'times'],
        class: "icon-base clickable p-mention",
        onClick: _ctx.closeHelper
      }, null, 8, ["onClick"])
    ]),
    _createVNode(_component_stripe_checkout, {
      ref: "checkoutRef",
      mode: "subscription",
      pk: _ctx.publishableKey,
      "line-items": _ctx.lineItems,
      "success-url": _ctx.successURL,
      "cancel-url": _ctx.cancelURL,
      onLoading: _cache[0] || (_cache[0] = (v) => (_ctx.loading = v))
    }, null, 8, ["pk", "line-items", "success-url", "cancel-url"]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        (_ctx._plan == _ctx.Package.Free)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " current "))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["p-mention rounded-mention text-center", {
            'btn-landing': _ctx.members.length > 0,
            'disabled-plan': _ctx.members.length == 0,
          }])
            }, " downgrade ", 2))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _hoisted_12,
        (_ctx._plan == _ctx.Package.Team)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " current "))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "p-mention rounded-mention text-center btn-primary font-semibold",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.upgradeToTeams && _ctx.upgradeToTeams(...args)))
            }, " upgrade "))
      ])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, "Package: " + _toDisplayString(_ctx._plan), 1),
      _createElementVNode("div", _hoisted_17, "Members: " + _toDisplayString(_ctx.members.length), 1),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("span", _hoisted_20, "$" + _toDisplayString(_ctx.cost) + " per year.", 1)
      ]),
      _createElementVNode("div", {
        class: "settings-link",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openStripe && _ctx.openStripe(...args)))
      }, [
        _hoisted_21,
        _createVNode(_component_Icon, {
          icon: ['fal', 'caret-right'],
          class: "icon-base link-caret"
        })
      ])
    ])
  ]))
}